<template>
  <!-- invite  -->
  <div v-if="getModalInfo.type == 'invite'">
    <VpFormModal id="passportActionFormModal" :showCloseIcon="true">
      <template v-slot:header>
        <span>{{ $t('users.form.inviteUserToDashboard') }}</span>
      </template>

      <template v-slot:content>
        <p class="Addaemail-phone">{{ $t('common.add') }} {{ $t('common.emailAddress') }} {{ $t('common.or') }} {{ $t('common.phoneNumber') }}</p>
        <!-- new email  -->
        <div class="email-input ">
          
          <VpInput v-model.trim="form.email" type="text" width="416" :placeholder="$t('common.emailAddress')" :label="$t('common.emailAddress')"
          :isLoading="emailLoading" :errMsg="!$v.form.email.email && form.email.length >= 3 ? $t('common.notes.invalidEmail') : emailDuplicated ? $t('common.notes.emailAddressAlreadyExists') : '' "
          :invalid="(!$v.form.email.email && form.email.length >= 3) || emailDuplicated" @input="checkDuplicationData('email')" />


        </div>
        <!-- current phone  -->
        <div class="current-phone" v-if="getModalInfo.data.phone && !updatePhone" >
          <div class="phone-group d-flex" >
            <label for="phone" class="label d-none d-md-block">{{ $t('common.phoneNumber') }}</label>
            <div id="phone" class="phone-number"> {{ getModalInfo.data.phone ? `+${getModalInfo.data.phone}` : "" }}</div>
          </div>
          <div class="phone-numbe-wrapper">
            <p @click="onUpdatePhone" class="update-text">{{ $t('common.change') }}</p>
          </div>
        </div>
        <!-- new phone  -->
        <div v-if="updatePhone || !getModalInfo.data.phone" class="phone-input">

          <!-- <div class="input-wrapper"> -->
            <div class="row-group phone-group justify-content-start">
              <VueCountryCode class="country-code-input" :disabledFetchingCountry="false" @onSelect="onSelectUserCountryCode"
                :enabledCountryCode="true" :preferredCountries="['GB', 'US', 'CN']" :class="phoneDuplicated && 'invalid-value'"
              />

              <VpInput v-model.trim="phone_input" type="number" :isLoading="phoneLoading" width="285" :placeholder="$t('common.phoneNumber')" :label="$t('common.phoneNumber')"
              :invalid="!$v.phone_input.numeric || phoneDuplicated" @input="duplicationData('phone')" />

            </div>
          <!-- </div> -->

          <div style="margin-top:8px!important;padding-inline-start:0px!important" class="err-wrapper">
            <!-- <div v-if="submitted && !$v.phone_input.required">
              <span class="error-value">Phone number is required</span>
            </div> -->
            <div v-if="!$v.phone_input.numeric">
              <span class="error-value">
                {{ $t('common.notes.phoneNumberOnlyDigits') }}
              </span>
            </div>
            <div v-else-if="!$v.phone_input.maxLength">
              <span class="error-value">
                {{ $t('users.form.phoneNumberExceed')}}
              </span>
            </div>
            <div v-if="phoneDuplicated">
              <span class="error-value">
                {{ $t('common.notes.phoneNumberAlreadyExists') }}
              </span>
            </div>
          </div>
        </div>

        <hr class="h-line input-h-line" />

        <VpMultiselect class="top-15" zIndex="10" :showPlaceholderIcon="true" width="416" :isLoading="userRolesLoading" :showOptionsBorder="true" 
          :showNoResults="true" v-model="user_role" label="name" :options="user_roles_list" :allowEmpty="true" :show-labels="false"
          :title="$t('common.userRole')" :disabled="!user_roles_list.length" :noResultMessage="$t('common.noResults')" 
          />

        <div v-if="user_role" class="roles-hint">
          <span><b>{{$t('common.notes.note')}}:</b> {{ $t('common.notes.rolesHint') }}</span>
        </div>
        
        <VpTreeselect class="top-15" zIndex="11" :showPlaceholderIcon="true" width="416" :showOptionsBorder="true" :showNoResults="true"
          v-model="form.sites"  :options="sitesOptions" :allowEmpty="true" :show-labels="true" :isLoading="sitesLoading"
          :label="$t('common.site')" :disabled="!sitesOptions.length"  :noResultMessage="$t('common.noResults')" />

        <VpTreeselect class="top-15" zIndex="12" :showPlaceholderIcon="true" width="416" :showOptionsBorder="true" :showNoResults="true"
          v-model="form.user_types"  :options="userTypesOptions" :allowEmpty="true" :show-labels="true" :isLoading="userTypesLoading"
          :label="$t('common.userType')" :disabled="!userTypesOptions.length"  :noResultMessage="$t('common.noResults')" dropDownStyle="relative" @onOpen="scrollToElement"/>

      </template>

      <template v-slot:footer>
        <VpButton :text="$t('common.invite')" ref="inviteSubmitBtn" @click="onSubmit" :disabled="getLoading || submitted || !(form.email || form.phone) 
          || $v.$invalid || emailDuplicated  || phoneDuplicated || !user_role || !form.sites.length|| !form.user_types.length" :isLoading="getLoading" />

        <VpButton :text="$t('common.cancel')" @click="$bvModal.hide('passportActionFormModal')" :isDanger="true" />
      </template>
    </VpFormModal>
  </div>

  <!-- revoke  -->
  <div v-else>
    <VpConfirmModal :modalId="'passportActionConfirmModal'">
      <template v-slot:title>
        <span>{{ $t('users.form.revokeUserFromDashboard') }}</span>
      </template>

      <template v-slot:text1>
        <span>{{ $t('common.notes.areYouSureYouWant') }} <strong>"{{ $t('common.revoke') }}"</strong> {{ getModalInfo.data.fullName }} {{ $t('users.form.fromDashboard') }}</span>
      </template>

      <template v-slot:buttons>
        <VpButton :text="$t('common.cancel')" @click="$bvModal.hide('passportActionConfirmModal')" />
        <VpButton :text="$t('common.revoke')" :isLoading="getLoading" :disabled="getLoading" :isDanger="true" @click="onSubmit()" />
      </template>
    </VpConfirmModal>
  </div>
</template>


<script>
import { debounce } from "lodash";
import { mapActions, mapGetters } from "vuex";
import {
  email,
  numeric,
  maxLength,
  requiredIf,
} from "vuelidate/lib/validators";
import VueCountryCode from "vue-country-code";
import userTypeService from "@/services/userType"

export default {
  name: "PassportAction",
  components: { VueCountryCode },
  data() {
    return {
      emailDuplicated: false,
      phoneDuplicated: false,
      multipleSelected: false,
      user_id: null,
      users_ids: null,
      form: {
        email: '',
        phone: '',
        system_user: true,
        sites : [],
        user_types : [],
      },
      submitted: false,
      user_role: null,
      user_roles_list: [],
      phone_input: '',
      updatePhone: false,
      sitesOptions : [],
      userTypesOptions : [],
      sitesLoading : true,
      userTypesLoading : true,
      userRolesLoading : true,
      phoneLoading : false,
      emailLoading : false,
    };
  },
  validations: {
    form: {
      email: {
        email,
        required: requiredIf(function() {
          const {
            form: { phone },
          } = this;
          return phone ? false : true;
        }),
      },
    },
    phone_input: {
      numeric,
      maxLength: maxLength(50),
      required: requiredIf(function() {
        const {
          form: { email,phone },
        } = this;
        return email || phone ? false : true;
      }),
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("users", ["getLoading"]),
    ...mapGetters("authfack", ["currentEntity"]),
  },
  watch: {
    getModalState(state) {
      if (state) {
        this.$bvModal.hide("passportActionFormModal");
        this.$bvModal.hide("passportActionConfirmModal");
      }
    },
    phone_input(phone_input) {
      this.form.phone =
        phone_input && phone_input.length > 0
          ? `${this.userCountryCode}${phone_input}`
          : null;
    },
  },
  methods: {
    ...mapActions("users", ["inviteInvokeUser", "resetLoading", "fetchUserRoles"]),
    ...mapActions("sites", [ "fetchAllSites" ]),
    ...mapActions("visit", ["fetchUsersByEmailOrPhone"]),
    scrollToElement(){
      setTimeout(() => {
        const el = this.$refs.inviteSubmitBtn;
        el?.scrollIntoView({behavior: 'smooth'});
      }, 0);
    },
    checkDuplicationData(type){
      
      let value = '';
      this.phoneLoading = false;
      this.emailLoading = false;
      this.submitted = true;

      if(type == 'email'){
        this.emailDuplicated = false;
        this.emailLoading = true;
        value = this.form.email;
      }else if(type == 'phone'){
        this.phoneLoading = true;
        this.phoneDuplicated  = false;
        value = this.phone_input ? this.userCountryCode + this.phone_input :'';
      }

      if(type && value && value.length >= 3){
        let formData = new FormData();
        formData.append('entity_id', this.currentEntity.id);
        formData.append('user_id', this.user_id ? this.user_id : '');
        formData.append('field', type);
        formData.append('value', value);
        setTimeout( async () => { 
          await this.fetchUsersByEmailOrPhone(formData).then((data) => {
            if(!data.data.available){
                if(data.data.field == 'email'){
                  this.emailDuplicated  = true;
                }else if(data.data.field == 'phone'){
                  this.phoneDuplicated  = true;
                }
            }
            this.emailLoading = false;
            this.phoneLoading = false;
            this.submitted = false;
          })
        },2000)
      }else{
        this.phoneLoading = false;
        this.emailLoading = false;
        this.submitted = false;
      }
    },
    onSubmit() {
      this.submitted = true;
      // this.$v.$touch();
      const {
        user_id,
        currentEntity,
        getModalInfo,
        users_ids,
        multipleSelected,
        inviteInvokeUser,
        form: { email, phone, sites, user_types },
      } = this;

      if (!this.$v.$error) {
        const obj = {
          user_ids: multipleSelected ? users_ids : [user_id],
          entity_id: currentEntity.id,
          type: getModalInfo.type,
          sites_ids : sites,
          user_types_ids : user_types,
          data: {
            email,
            phone,
            system_user: getModalInfo.type == "revoke" ? 0 : 1,
          },
        };
        if (getModalInfo.type == "invite") obj.role_id = this.user_role.id;
          
        inviteInvokeUser(obj).then(()=>{
          // console.log('aaaaaa');
          this.$emit('changeUserStatusOrDeleted');
          if (getModalInfo.type == "invite") {
            this.$emit("changeUsersPassportStatus", obj.user_ids);
          }
        }).catch((err) => {
          // console.log('invite err', err.data.errors.email);
          if (err.data.errors.email) this.emailDuplicated = true;
          if (err.data.errors.phone) this.phoneDuplicated = true;
        });
      }
    },
    onSelectUserCountryCode({ dialCode }) {
      this.phoneDuplicated = false;
      this.userCountryCode = dialCode;
      this.form.phone =
        this.phone_input && this.phone_input.length > 0
          ? `${this.userCountryCode}${this.phone_input}`
          : null;
    },
    onUpdatePhone() {
      this.updatePhone = true;
      this.form.phone = null;
    },
  },
  created() {
    this.duplicationData = debounce(this.checkDuplicationData.bind(this), 1000); 
  },
  async beforeMount() {
    this.fetchUserRoles().then((data) => {

      this.user_roles_list = data.data;
      this.userRolesLoading = false;
    });

    
    const {data} = await userTypeService.getPermittedUserTypes()
    
    data?.forEach( (item) => {
      if(!item?.children?.length)
        delete item.children;             
      this.userTypesOptions.push(item);
    });

    this.userTypesLoading = false;

    this.fetchAllSites().then((data)=>{
        this.sitesOptions = data.data;
        this.sitesLoading = false;
    });

    this.resetLoading();
    this.form.phone = this.getModalInfo.data.phone;
    this.form.email = this.getModalInfo.data.email ?? '';
    if (Array.isArray(this.getModalInfo.data)) {
      this.multipleSelected = true;
      this.users_ids =
        this.getModalInfo.data.length > 0 &&
        this.getModalInfo.data.map((user) => user.UniqueId);
    } else {
      this.user_id = this.getModalInfo.data.id;
    }
  },
};
</script>

<style lang="scss" scoped>
  .vue-country-select {
    height: 56px;
    z-index: auto;
    margin-inline-end: 0.7rem;
    border: 0;
    border-radius: 4px !important;
    width: 120px;
    &:focus div {
      outline: none !important;
      border: 0 !important;
    }
    background: #f2f2f2;
    color: #606060;
  }
  .row-group {
    display: flex;
    justify-content: space-between;
    width: 416px;
  }
  .input-h-line {
    margin: 24px 0 24px 0;
  }
  .email-input {
    .err-wrapper {
    margin-top: -8px;
    margin-bottom: 14px;
  }
}
.phone-input {
  margin-bottom: 3px;
  .err-wrapper {
    margin-top:  5px;
    margin-inline-start: 2px;
  }
  .error-value{
    margin-top:  5px;
    margin-inline-start: 2px;
  }
}
  .select-role {
    .input-wrapper {
      display: flex;
      align-items: center;
      background-color: #f3f3f3;
      height: 55px;
    }
  }

</style>
<style lang="scss">
.vue-country-select .dropdown-list {
  z-index: 11 !important;
}
.top-15{
  margin-top: 15px !important;
}
</style>